var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (universalLoginApp) {pug_html = pug_html + "\u003Cdiv class=\"universal-login-page\"\u003E\u003Cdiv id=\"js-universal-login-app\"\u003E" + (null == (pug_interp = universalLoginApp) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"universalLoginApp" in locals_for_with?locals_for_with.universalLoginApp:typeof universalLoginApp!=="undefined"?universalLoginApp:undefined));;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/universal-login/view/index.pug
// module id = 1410
// module chunks = 0